export default __webpack_public_path__ + "images/fb26f6cc98810d92dac6e918ebe36a97-EE_SlideDeckBOOK1024_6.png";